import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import TaskOverview from "../../components/taskoverview/TaskOverview";
import Button from "../../components/cofButton/Button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatDate, formatBirth } from '../../components/dateUtils';
import './PlayerHomeScreen.css';

const PlayerHomeScreen = ({ userInfo, context }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goToDailySurvey = () => {
    navigate("/daily-survey");
  };

  return (
    <div className="player-home-container">
      {/* Welcome Hero Section */}
      <div className="tasks-container">
        <div className="welcome-hero">
          <h2 className="welcome-title">
            <span className="gradient-text">{t("welcome")}</span>, {userInfo.name} {userInfo.surname}!
          </h2>
          <p className="welcome-subtitle">
            {t("welcomeDashboard")}
          </p>
        </div>
      </div>

      {/* Daily Status Card */}
      <div className="tasks-container">
        {context && context.dailyStatus && context.dailyStatus.length > 0 ? (
          <div className={`status-card status-completed`}>
            <h3 className="status-title">✅ {t("tnxTheCompleteDaileySurvey")}</h3>
            <p className="welcome-subtitle">{t("Your last daily input is")}:</p>
            
            <div className="status-details">
              <div className="status-item">
                <h5>
                  <span className="status-icon fitness">💪</span>
                  {t("Fitness status today")}: {context.dailyStatus[0].physicalStatus}
                </h5>
              </div>
              <div className="status-item">
                <h5>
                  <span className="status-icon mental">🧠</span>
                  {t("Mental status today")}: {context.dailyStatus[0].mentalStatus}
                </h5>
              </div>
              <div className="status-item">
                <h5>
                  <span className="status-icon sleep">😴</span>
                  {t("ocenakvalitetasna")}: {context.dailyStatus[0].sleepStatus}
                </h5>
              </div>
            </div>

            <button
              className="modern-action-btn"
              onClick={goToDailySurvey}
            >
              {t("Edit Daily Status")}
            </button>
          </div>
        ) : (
          <div className={`status-card status-pending`}>
            <h3 className="status-title">⏰ {t("notCompletedailySurvey")}</h3>
            <p className="welcome-subtitle">
              {t("pleaseCompleteDailySurvey")}
            </p>
            <button
              className="modern-action-btn"
              onClick={goToDailySurvey}
            >
              {t("completeSurvey")}
            </button>
          </div>
        )}
      </div>

      {/* Tasks for Today Section */}
      <div className="tasks-container">
        <h3 className="section-header">{t("taskForToday")}</h3>
        {context &&
          context.scheduledTasksForToday &&
          context.scheduledTasksForToday.length > 0 ? (
          <div className="tasks-grid">
            {context.scheduledTasksForToday.map((task) => (
              <div key={task._id} className="task-overview-enhanced">
                <TaskOverview
                  task={task.name}
                  description={task.description}
                  time={formatDate(task.startTime)}
                  location={task.location}
                  scheduledTaskId={task._id}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="no-tasks-message">
            <div className="no-tasks-icon">📅</div>
            <p>{t("noTasksforToday")}</p>
          </div>
        )}
      </div>

      {/* Tasks for Last 7 Days Section */}
      <div className="tasks-container">
        <h3 className="section-header">{t("Last7days")}</h3>
        {context &&
          context.scheduledTasksForThisWeek &&
          context.scheduledTasksForThisWeek.length > 0 ? (
          <div className="tasks-grid">
            {context.scheduledTasksForThisWeek.map((task) => (
              <div key={task._id} className="task-overview-enhanced">
                <TaskOverview
                  task={task.name}
                  description={task.description}
                  time={formatDate(task.startTime)}
                  location={task.location}
                  scheduledTaskId={task._id}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="no-tasks-message">
            <div className="no-tasks-icon">📊</div>
            <p>{t("noTasksFor7")}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PlayerHomeScreen;
